/**
 * Canonical legal page URLs.
 *
 * All /legal/* pages are now self-hosted on adulab.app (Wave 1 + Wave 2,
 * completed 2026-05-26). LEGAL_URLS contains absolute URLs for external
 * use cases (transactional emails, Stripe Dashboard, marketing assets) and
 * for any caller that genuinely needs a fully-qualified link to a legal
 * page on adulab.app.
 *
 * For in-app navigation, prefer the relative `.route` field on each entry
 * in `legalDocumentRegistry.ts` — it is the single source of truth for the
 * Footer + LegalHub + LegalDocument layout.
 *
 * LEGAL_REDIRECTS is intentionally empty: there are no longer any
 * external /legal/* destinations to redirect to. The empty map is preserved
 * (rather than deleted) so the App.jsx route iteration remains stable; if
 * any future legal page lives off-platform, add it back here.
 */
const LEGAL_BASE = 'https://adulab.app/legal';

export const LEGAL_URLS = {
  index:                LEGAL_BASE,
  privacy:              `${LEGAL_BASE}/privacy`,
  cookiePolicy:         `${LEGAL_BASE}/cookie-policy`,
  terms:                `${LEGAL_BASE}/terms`,
  serviceTerms:         `${LEGAL_BASE}/service-terms`,
  paymentTerms:         `${LEGAL_BASE}/payment-terms`,
  refundPolicy:         `${LEGAL_BASE}/refund-policy`,
  advertisingTerms:     `${LEGAL_BASE}/advertising-terms`,
  dataProcessing:       `${LEGAL_BASE}/data-processing`,
  regionalPrivacy:      `${LEGAL_BASE}/regional-privacy`,
  emailDisclaimer:      `${LEGAL_BASE}/email-disclaimer`,
  assessmentDisclaimer: `${LEGAL_BASE}/assessment-disclaimer`,
  reportsDisclaimer:    `${LEGAL_BASE}/reports-disclaimer`,
  aiDisclosure:         `${LEGAL_BASE}/ai-disclosure`,
  dmca:                 `${LEGAL_BASE}/dmca`,
  trustSafety:          `${LEGAL_BASE}/trust-safety`,
};

/**
 * Map of local route paths to external legal URLs.
 * Intentionally empty after Wave 2 — all /legal/* destinations are
 * self-hosted on adulab.app. Preserved as an empty object to keep
 * App.jsx route iteration stable.
 */
export const LEGAL_REDIRECTS = {};
